import type { TipoManutencao } from "@/modules/financeiro-obras";
import type { useIdentificacaoEquipamento } from "../../../../../hooks/use-identificacao-equipamento";
import {
  FALHA_EQUIPAMENTOS,
  REVISAO_SEM_VALOR,
  SEM_EQUIPAMENTO,
  TIPOS_MANUTENCAO,
} from "../adicionar-escopo-macro-dialog.constants";
import type { ErrosForm, Rascunho } from "../adicionar-escopo-macro-dialog.rascunho";
import type { IdentificacaoEquipamentoViewModel } from "./types-identificacao-equipamento";

interface Entrada {
  dados: ReturnType<typeof useIdentificacaoEquipamento>;
  rascunho: Rascunho;
  erros: ErrosForm;
  escolherGrupo: (grupo: string) => void;
  escolherEquipamento: (id: string) => void;
  escolherTipoManutencao: (valor: TipoManutencao) => void;
}

export function montarIdentificacaoEquipamento({
  dados,
  rascunho,
  erros,
  escolherGrupo,
  escolherEquipamento,
  escolherTipoManutencao,
}: Entrada) {
  const { equipamento, composto } = dados;
  const aviso = dados.semEquipamento
    ? { texto: SEM_EQUIPAMENTO, tom: "info" as const }
    : dados.comFalha
      ? { texto: FALHA_EQUIPAMENTOS, tom: "erro" as const }
      : null;

  const viewModel: IdentificacaoEquipamentoViewModel = {
    grupo: {
      value: rascunho.grupo || null,
      opcoes: dados.grupos.map((valor) => ({ label: valor, value: valor })),
      erro: erros.grupo ?? null,
      desabilitado: !dados.carregado || dados.semEquipamento,
      onChange: escolherGrupo,
    },
    equipamento: {
      value: rascunho.equipamentoSfiId || null,
      opcoes: dados.equipamentos.map((item) => ({
        label: `${item.codigo} · ${item.descricao}`,
        value: item.id,
      })),
      erro: erros.equipamentoSfiId ?? null,
      desabilitado: rascunho.grupo === "",
      onChange: escolherEquipamento,
    },
    tipoManutencao: {
      value: rascunho.tipoManutencao || null,
      opcoes: TIPOS_MANUTENCAO.map((valor) => ({ label: valor, value: valor })),
      erro: erros.tipoManutencao ?? null,
      desabilitado: equipamento === null,
      onChange: escolherTipoManutencao,
    },
    fabricante: equipamento?.fabricante ?? "",
    modelo: equipamento?.modelo ?? "",
    revisao: composto?.revisaoAplicavel
      ? composto.revisaoMilHoras === null
        ? REVISAO_SEM_VALOR
        : String(composto.revisaoMilHoras)
      : null,
    nome: composto?.nome ?? null,
    aviso,
  };

  const aguardandoNome =
    equipamento !== null && rascunho.tipoManutencao !== "" && composto === null;
  return { viewModel, bloqueado: aviso !== null || aguardandoNome };
}
